export enum steps {
  REGISTER = 'auth.register.steps.step1',
  CODE = 'auth.register.steps.step2',
  TFA = 'auth.register.steps.step3',
  INTRO = 'auth.register.steps.step4',
  COMPLETE = 'auth.register.steps.complete',
}
